import { Inspector } from './Inspector';
import { InspectorConsole } from './Inspector/InspectorConsole';
import { Interpreter } from './Interpreter';
import { StateMachine } from './StateMachine';
import { isDevelopment } from './util';
import { ensureFsmDevToolsBridge, registerMachine } from './devtools';
function captureCallerFile() {
  try {
    var _Error$stack;
    const lines = ((_Error$stack = new Error().stack) !== null && _Error$stack !== void 0 ? _Error$stack : '').split('\n');
    for (const line of lines) {
      var _url$split$0$split$fi;
      const match = line.match(/\(?((?:https?:|webpack:|bpm:)\/\/[^\s)]+)\)?/);
      if (!match) continue;
      const url = match[1].replace(/:\d+(?::\d+)?$/, '');
      if (/\/fsm\/static/.test(url) || /webpack:\/\/fsm\//.test(url) || /(?:^|\/)fsm@[^/]+\/js\//.test(url) || /\/node_modules\//.test(url) || /[/.]bpm\//.test(url)) {
        continue;
      }
      const fileName = (_url$split$0$split$fi = url.split(/[?#]/)[0].split('/').filter(Boolean).pop()) !== null && _url$split$0$split$fi !== void 0 ? _url$split$0$split$fi : '';
      if (fileName) return fileName;
    }
  } catch (_unused) {
    // best-effort — ignore errors
  }
  return undefined;
}
function buildDefaultInspector(name, sourceFile) {
  return new Inspector({
    initialStatus: 'running',
    name,
    sourceFile
  });
}
export function createMachine(machineDefinition, options = {}) {
  const inspector = options.inspector || (options.debug ? new InspectorConsole({
    name: options.name || machineDefinition.initial
  }) : buildDefaultInspector(options.name, isDevelopment() ? captureCallerFile() : undefined));
  const machine = new StateMachine(machineDefinition, inspector, options.debug || false);
  const interpreter = new Interpreter(machine, options.initialContext);
  if (!options.waitToStart) {
    interpreter.start();
  }
  if (isDevelopment()) {
    registerMachine(interpreter);
    ensureFsmDevToolsBridge();
  }
  return interpreter;
}